<template>
  <header class="header">
    <div class="header__container">
      <app-logo
        class="logo"
        type="image"
      />

      <language-switcher class="header__language" />
    </div>
  </header>
</template>

<script setup>
import AppLogo from '&/atoms/AppLogo'
import LanguageSwitcher from '&/atoms/LanguageSwitcher'
</script>

<style lang="scss" scoped>
.header {
  padding: 6px 12px;

  @include mq(sm) {
    padding: 12px;
  }

  @include mq(md) {
    padding: 12px 24px;
  }

  &__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }
}

:deep() {
  .logo {
    max-width: 170px;
    max-height: 40px;

    @include mq(sm) {
      max-width: 190px;
      max-height: 55px;
    }
  }
}
</style>
